<script lang="ts" setup>
import { routerBack } from "@/use/go";
import LightArrowIcon from "@/components/icon/LightArrowIcon.vue";
import { nextTick, ref } from "vue";

const props = withDefaults(
  defineProps<{
    showBack: boolean;
    className: string;
  }>(),
  {
    showBack: true,
  }
);

const isFixed = ref(false);
const stickyNav = ref(null);
const onFixChange = (fixed: boolean) => {
  isFixed.value = fixed;
  if (fixed) {
    nextTick(() => {
      const fixedEl = document.querySelector(
        ".sticky-nav .van-sticky.van-sticky--fixed"
      );
      fixedEl?.classList.add("van-safe-area-top");
    });
  }
};
</script>
<template>
  <van-sticky ref="stickyNav" class="sticky-nav" @change="onFixChange">
    <div :class="className" class="flex items-center h-top-nav p-2 gap-1">
      <button
        v-if="isFixed && showBack"
        class="btn btn-ghost"
        @click="routerBack({})"
      >
        <light-arrow-icon />
      </button>
      <slot></slot>
    </div>
  </van-sticky>
</template>
